module.exports = __webpack_public_path__ + "static/media/01C.3c0ed884.png";